import { render } from "./NavGroup.vue?vue&type=template&id=dc0708ae"
import script from "./NavGroup.vue?vue&type=script&lang=js"
export * from "./NavGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__